import { useState, useEffect } from 'react'
import { updateV2State } from './startModal'

export function createDataSource(initState) {
    let globalState = initState
    let listeners = {}
    // 兼容不支持entries
    if (Object.fromEntries && Object.entries) {
        listeners = Object.fromEntries(Object.entries(initState).map(([key, value]) => [key, new Set([])]))
    } else {
        for (const val in initState) {
            if (val) {
                listeners[val] = new Set([])
            }
        }
    }
    const setGlobalState = (key, nextValue) => {
        if (typeof nextValue === 'function') {
            globalState = { ...globalState, [key]: nextValue(globalState[key]) }
        } else {
            globalState = { ...globalState, [key]: nextValue }
        }
        updateV2State(globalState)
        listeners[key] &&
            listeners[key].forEach((listener) => {
                listener()
            })
    }
    const useSetGlobalState = (key) => {
        const [state, setState] = useState(globalState[key])
        useEffect(() => {
            const listener = () => {
                setState(globalState[key])
            }
            listeners[key] && listeners[key].add(listener)
            listener() // in case it's already changed
            return () => listeners[key] && listeners[key].delete(listener) // cleanup
        }, [])
        return [
            state,
            (newValue) => {
                setGlobalState(key, newValue)
            }
        ]
    }
    return {
        setGlobalState,
        useSetGlobalState
    }
}
